import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MenuItem from './menuItem';
import MenuItemSoon from './menuItemSoon';
import MenuTree from './menuTree';
import MenuSection from './menuSection';
import MenuSidebarContext from './menuSidebarContext';
import PermissaoUsuario from '../../auth/permissao';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { openTreeId: null };
    this.setOpenTreeId = this.setOpenTreeId.bind(this);
  }

  setOpenTreeId(id) {
    this.setState({ openTreeId: id });
  }

  render() {
    const user = this.props.user || {};
    const userGroupId = user.grupo_idgrupo;
    const config = this.props.config || {};
    const usaAdaptativo = config.usa_adaptativo;
    const moduloContagem = config.modulo_contagem;
    const isAdmin = userGroupId !== 28;

    return (
      <MenuSidebarContext.Provider
        value={{ openTreeId: this.state.openTreeId, setOpenTreeId: this.setOpenTreeId }}
      >
        <ul className="sidebar-menu">
          <MenuSection label="Visão geral" />

          <MenuItem path="/" label="Dashboard" icon="tachometer-alt" />

          <MenuSection label="Configuração" />

          <MenuTree
            id="cadastros"
            label="Cadastros"
            icon="edit"
            paths={['/cadgrupo', '/cadusuario', '/cadgrupofisico', '/cadcontrolador']}
          >
            {isAdmin && <MenuItem path="/cadgrupo" label="Grupo de Usuários" icon="users-cog" />}
            {isAdmin && <MenuItem path="/cadusuario" label="Usuários" icon="user" />}
            {isAdmin && <MenuItem path="/cadgrupofisico" label="Grupo Físico" icon="server" />}
            <MenuItem path="/cadcontrolador" label="Controlador" icon="microchip" />
          </MenuTree>

          <MenuSection label="Operação" />

          <MenuTree
            id="controlador"
            label="Controlador"
            icon="traffic-light"
            paths={[
              '/cadplano',
              '/cadtrocaplano',
              '/caddataespecial',
              '/execplanoforcado',
              '/concontroladorerro',
              '/contagemvolumetrica',
              '/log-adaptativo',
            ]}
          >
            <MenuItem path="/cadplano" label="Planos do Controlador" icon="sitemap" />
            <MenuItem path="/cadtrocaplano" label="Tabela de Troca de Plano" icon="exchange-alt" />
            <MenuItem path="/caddataespecial" label="Datas Especiais" icon="calendar-alt" />
            <MenuItem path="/execplanoforcado" label="Plano Forçado" icon="gavel" />
            <MenuItem path="/concontroladorerro" label="Registro de Defeitos" icon="bug" />
            {moduloContagem && <MenuItem path="/contagemvolumetrica" label="Contagem Volumétrica" icon="car" />}
            {isAdmin && usaAdaptativo && (
              <MenuItem path="/log-adaptativo" label="Histórico Adaptativo" icon="chart-line" />
            )}
          </MenuTree>

          <MenuItem path="/mapadefases" label="Mapa de Fases" icon="map-marked-alt" />

          {config.modulo_alertas_trafego && <MenuItem path="/transito" label="Trânsito" icon="road" />}

          {config.modulo_waze && <MenuItem path="/mapa-waze" label="Mapa Waze" icon="map" />}

          {isAdmin && <MenuItem path="/concontroladorerrogeral" label="Notificações" icon="exclamation-triangle" />}

          <MenuSection label="Dispositivos" />

          <MenuItemSoon label="Nobreak" icon="battery-full" message="Em breve" />

          {config.modulo_pluviometrico && (
            <MenuTree
              id="pluviometrico"
              label="Pluviometro"
              icon="tint"
              paths={['/pluviometro-tempo-real', '/pluviometro-historico', '/pluviometro-mapa', '/pluviometro']}
            >
              <MenuItem path="/pluviometro-tempo-real" label="Tempo Real" icon="tachometer-alt" />
              <MenuItem path="/pluviometro-historico" label="Histórico" icon="chart-line" />
              <MenuItem path="/pluviometro-mapa" label="Mapa Pluviométrico" icon="map-marked-alt" />
            </MenuTree>
          )}

          <MenuTree
            id="cameras"
            label="Câmeras"
            icon="camera"
            paths={['/cameradeteccao', '/cameramonitoramento', '/cadcamera']}
          >
            <MenuItem path="/cameradeteccao" label="Câmera de Detecção" icon="video" />
            <MenuItem path="/cameramonitoramento" label="Câmera Monitoramento" icon="video" />
            {isAdmin && <MenuItem path="/cadcamera" label="Cadastro de Câmeras" icon="edit" />}
          </MenuTree>

          <MenuSection label="Manutenção" />

          {config.modulo_manutencao && (
            <MenuTree
              id="manutencao"
              label="Manutenção"
              icon="wrench"
              paths={[
                '/manutencao-os',
                '/manutencao-mapa',
                '/manutencao-mapa-viaturas',
                '/manutencao-equipes',
                '/manutencao-viaturas',
                '/manutencao-estoque',
                '/manutencao-inventario',
              ]}
            >
              <PermissaoUsuario tela="CadOrdemServico" condicao={true}>
                <MenuItem path="/manutencao-os" label="Ordens de Serviço" icon="clipboard-list" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="ManutencaoMapa" campo="mapa_os" condicao={true}>
                <MenuItem path="/manutencao-mapa" label="Mapa de OS" icon="map-marked-alt" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="ManutencaoMapa" campo="mapa_viaturas" condicao={true}>
                <MenuItem path="/manutencao-mapa-viaturas" label="Mapa de Viaturas" icon="truck" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEquipe" condicao={true}>
                <MenuItem path="/manutencao-equipes" label="Equipes" icon="user-friends" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoViatura" condicao={true}>
                <MenuItem path="/manutencao-viaturas" label="Viaturas" icon="truck" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEstoque" condicao={true}>
                <MenuItem path="/manutencao-estoque" label="Estoque" icon="boxes" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoInventario" condicao={true}>
                <MenuItem path="/manutencao-inventario" label="Inventário" icon="toolbox" />
              </PermissaoUsuario>
            </MenuTree>
          )}

          {config.modulo_tickets && (
            <MenuItem path="/ticketsuporte" label="Tickets de Suporte" icon="ticket-alt" />
          )}

          <MenuTree id="comunicacao" label="Comunicação" icon="bell" paths={['/telegram']}>
            <MenuItem path="/telegram" label="Telegram" icon="paper-plane" />
          </MenuTree>

          <MenuSection label="Administração" />

          {isAdmin && <MenuItem path="/conlogusuario" label="Auditoria" icon="history" />}
        </ul>
      </MenuSidebarContext.Provider>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  config: state.auth.config,
});

export default connect(mapStateToProps)(withRouter(Menu));
